import { render } from "./net-table.vue?vue&type=template&id=2e6583b2&scoped=true"
import script from "./net-table.vue?vue&type=script&lang=ts"
export * from "./net-table.vue?vue&type=script&lang=ts"

import "./net-table.vue?vue&type=style&index=0&id=2e6583b2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2e6583b2"

export default script